export default {
  pageTitle: '参与促销的商品',
  radio1: '待审核',
  radio2: '已通过',
  radio3: '已拒绝',
  radio4: '已取消',
  time1: '报名时间',
  typeEvent: '活动类型',
  placeholder1: '活动ID',
  placeholder2: 'Listing ID',
  placeholder3: '商品名',
  typeList1: '所有',
  typeList2: '满减',
  statusDisplaylist1: '待审核',
  statusDisplaylist2: '尚未开始',
  statusDisplaylist3: '进行中',
  statusDisplaylist4: '已过期',
  statusDisplaylist5: '取消或拒绝',
  statuslist1: '待审核',
  statuslist2: '已通过',
  statuslist3: '已拒绝',
  statuslist4: '已取消',
  columns1: '报名ID',
  columns2: 'Listing ID',
  columns3: '商品名',
  columns4: '价格区间',
  columns5: '报名状态',
  columns6: '促销活动ID',
  columns7: '活动名',
  columns8: '创建时间',
  columns9: '活动类型',
  columns10: '促销活动内容',
  columns11: '活动状态',
  columns12: '已报名商品',
  columns13: '详情',
  confirmContent: '确定取消吗'
}
